(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-capsule-studio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = new Map();
    var TAU = Math.PI * 2;
    var DEG = Math.PI / 180;

    // Side profile measured on the Monte Capra product cut-outs, in flange radii.
    // [radius, depth from the lid plane, material, subdivisions]
    var PROFILE = [
      [1, 0, 'rim', 1],
      [1, -0.05, 'under', 2],
      [0.76, -0.05, 'body', 2],
      [0.69, -1.26, 'shoulder', 4],
      [0.67, -1.36, 'shoulder', 4],
      [0.61, -1.46, 'shoulder', 4],
      [0.52, -1.54, 'shoulder', 3],
      [0.45, -1.6, 'body', 2],
      [0.2, -1.6, 'body', 1],
      [0.16, -1.585, 'body', 1],
      [0, -1.585]
    ];
    var LOBES = 10;
    var LOBE_DEPTH = 0.05;
    var SLICES = 88;
    var CENTER_Z = -0.8;
    var EXTENT = 1.34;
    var LID_PRINT = 0.9;
    var LOGO_SAFE = 0.72;
    var SILVER = [0.74, 0.76, 0.79];

    function qAxis(x, y, z, angle) {
      var s = Math.sin(angle / 2);
      return [Math.cos(angle / 2), x * s, y * s, z * s];
    }

    function qMul(a, b) {
      return [
        a[0] * b[0] - a[1] * b[1] - a[2] * b[2] - a[3] * b[3],
        a[0] * b[1] + a[1] * b[0] + a[2] * b[3] - a[3] * b[2],
        a[0] * b[2] - a[1] * b[3] + a[2] * b[0] + a[3] * b[1],
        a[0] * b[3] + a[1] * b[2] - a[2] * b[1] + a[3] * b[0]
      ];
    }

    function qNorm(q) {
      var l = Math.hypot(q[0], q[1], q[2], q[3]) || 1;
      return [q[0] / l, q[1] / l, q[2] / l, q[3] / l];
    }

    function qSlerp(a, b, t) {
      var d = a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
      if (d < 0) {
        b = [-b[0], -b[1], -b[2], -b[3]];
        d = -d;
      }
      if (d > 0.9995) {
        return qNorm([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t, a[3] + (b[3] - a[3]) * t]);
      }
      var th = Math.acos(d);
      var s = Math.sin(th);
      var wa = Math.sin((1 - t) * th) / s;
      var wb = Math.sin(t * th) / s;
      return [a[0] * wa + b[0] * wb, a[1] * wa + b[1] * wb, a[2] * wa + b[2] * wb, a[3] * wa + b[3] * wb];
    }

    function qMatrix(q) {
      var w = q[0], x = q[1], y = q[2], z = q[3];
      return [
        1 - 2 * (y * y + z * z), 2 * (x * y - w * z), 2 * (x * z + w * y),
        2 * (x * y + w * z), 1 - 2 * (x * x + z * z), 2 * (y * z - w * x),
        2 * (x * z - w * y), 2 * (y * z + w * x), 1 - 2 * (x * x + y * y)
      ];
    }

    function apply(m, x, y, z) {
      return [m[0] * x + m[1] * y + m[2] * z, m[3] * x + m[4] * y + m[5] * z, m[6] * x + m[7] * y + m[8] * z];
    }

    var VIEWS = {
      hero: qMul(qAxis(0, 1, 0, -14 * DEG), qAxis(1, 0, 0, -58 * DEG)),
      front: [1, 0, 0, 0],
      side: qAxis(1, 0, 0, 90 * DEG),
      top: qAxis(0, 1, 0, 180 * DEG)
    };

    function hexToRgb(hex) {
      var m = /^#?([0-9a-f]{6})$/i.exec(String(hex).trim());
      if (!m) return [0.1, 0.1, 0.1];
      var n = parseInt(m[1], 16);
      return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
    }

    function rgb(c) {
      return 'rgb(' + Math.round(Math.min(1, Math.max(0, c[0])) * 255) + ',' +
        Math.round(Math.min(1, Math.max(0, c[1])) * 255) + ',' +
        Math.round(Math.min(1, Math.max(0, c[2])) * 255) + ')';
    }

    function seeded(seed) {
      return function () {
        seed = (seed * 16807) % 2147483647;
        return (seed - 1) / 2147483646;
      };
    }

    function buildMesh() {
      var rings = [];
      var mats = [];
      for (var s = 0; s < PROFILE.length - 1; s += 1) {
        var a = PROFILE[s];
        var b = PROFILE[s + 1];
        for (var k = 0; k < a[3]; k += 1) {
          var t = k / a[3];
          rings.push({ r: a[0] + (b[0] - a[0]) * t, z: a[1] + (b[1] - a[1]) * t });
          mats.push(a[2]);
        }
      }
      var last = PROFILE[PROFILE.length - 1];
      rings.push({ r: last[0], z: last[1] });

      var zTop = -1.3;
      var zBottom = -1.56;
      var verts = rings.map(function (ring) {
        var band = (ring.z - zTop) / (zBottom - zTop);
        var weight = band > 0 && band < 1 ? Math.sin(band * Math.PI) : 0;
        var row = [];
        for (var i = 0; i < SLICES; i += 1) {
          var th = (i / SLICES) * TAU;
          var r = ring.r * (1 - LOBE_DEPTH * weight * (0.5 + 0.5 * Math.cos(LOBES * th)));
          row.push([r * Math.cos(th), r * Math.sin(th), ring.z]);
        }
        return row;
      });

      var random = seeded(7);
      var grain = [];
      for (var g = 0; g < SLICES; g += 1) grain.push(random() * 2 - 1);
      grain = grain.map(function (v, i) {
        return (v + grain[(i + 1) % SLICES] * 0.6 + grain[(i + SLICES - 1) % SLICES] * 0.6) / 2.2;
      });

      var quads = [];
      for (var k2 = 0; k2 < rings.length - 1; k2 += 1) {
        for (var i2 = 0; i2 < SLICES; i2 += 1) {
          var j = (i2 + 1) % SLICES;
          var p = [verts[k2][i2], verts[k2][j], verts[k2 + 1][j], verts[k2 + 1][i2]];
          var n = [0, 0, 0];
          for (var e = 0; e < 4; e += 1) {
            var c = p[e];
            var d = p[(e + 1) % 4];
            n[0] += (c[1] - d[1]) * (c[2] + d[2]);
            n[1] += (c[2] - d[2]) * (c[0] + d[0]);
            n[2] += (c[0] - d[0]) * (c[1] + d[1]);
          }
          var l = Math.hypot(n[0], n[1], n[2]) || 1;
          quads.push({ p: p, n: [n[0] / l, n[1] / l, n[2] / l], mat: mats[k2] });
        }
      }
      var probe = quads.filter(function (q) { return q.mat === 'body'; })[0];
      var mid = probe.p[0];
      if (probe.n[0] * mid[0] + probe.n[1] * mid[1] < 0) {
        quads.forEach(function (q) { q.n = [-q.n[0], -q.n[1], -q.n[2]]; });
      }
      var blend = function (a, b) {
        var x = a[0] + b[0], y = a[1] + b[1], z = a[2] + b[2];
        var l = Math.hypot(x, y, z) || 1;
        return [x / l, y / l, z / l];
      };
      quads.forEach(function (q, index) {
        var ring = index - (index % SLICES);
        var slice = index % SLICES;
        q.nl = blend(quads[ring + ((slice + SLICES - 1) % SLICES)].n, q.n);
        q.nr = blend(q.n, quads[ring + ((slice + 1) % SLICES)].n);
        q.gl = (grain[(slice + SLICES - 1) % SLICES] + grain[slice]) / 2;
        q.gr = (grain[slice] + grain[(slice + 1) % SLICES]) / 2;
      });
      return quads;
    }

    var KEY = [-0.55, 0.62, 0.56];
    var STRIP = [0.9, 0.06, 0.43];
    var BOUNCE = [0.2, -0.76, 0.62];

    function environment(n) {
      var rx = 2 * n[2] * n[0];
      var ry = 2 * n[2] * n[1];
      var rz = 2 * n[2] * n[2] - 1;
      var key = Math.max(0, rx * KEY[0] + ry * KEY[1] + rz * KEY[2]);
      var strip = Math.max(0, rx * STRIP[0] + ry * STRIP[1] + rz * STRIP[2]);
      var bounce = Math.max(0, rx * BOUNCE[0] + ry * BOUNCE[1] + rz * BOUNCE[2]);
      return 0.1 + Math.pow(key, 4) + 0.75 * Math.pow(strip, 14) + 0.3 * Math.pow(bounce, 4) + 0.22 * Math.max(0, ry) + 0.18 * Math.pow(Math.max(0, rz), 3) - 0.05 * Math.max(0, -ry);
    }

    function material(base, mat) {
      if (mat === 'rim') return { base: SILVER, spec: [1, 1, 1], diffuse: 0.55, gloss: 1 };
      var luma = base[0] * 0.3 + base[1] * 0.59 + base[2] * 0.11;
      var tint = luma < 0.12 ? 0.6 : 0.42;
      var warm = [base[0] + (1 - base[0]) * tint, base[1] + (0.86 - base[1]) * tint, base[2] + (0.72 - base[2]) * tint];
      return { base: base, spec: warm, diffuse: luma < 0.12 ? 0.35 : 0.6, gloss: luma < 0.12 ? 0.8 : 0.9 };
    }

    function shade(m, n, grain) {
      var diffuse = Math.max(0, n[0] * KEY[0] + n[1] * KEY[1] + n[2] * KEY[2]);
      var env = environment(n) * m.gloss;
      var streak = 1 + 0.07 * grain;
      return [
        (m.base[0] * (0.2 + m.diffuse * diffuse) + m.spec[0] * env) * streak,
        (m.base[1] * (0.2 + m.diffuse * diffuse) + m.spec[1] * env) * streak,
        (m.base[2] * (0.2 + m.diffuse * diffuse) + m.spec[2] * env) * streak
      ];
    }

    function buildLid(size, logo) {
      var c = document.createElement('canvas');
      c.width = size;
      c.height = size;
      var ctx = c.getContext('2d');
      var r = size / 2;
      ctx.translate(r, r);
      var foil = ctx.createRadialGradient(-r * 0.25, -r * 0.3, r * 0.1, 0, 0, r);
      foil.addColorStop(0, '#e4e6e9');
      foil.addColorStop(1, '#b4b8be');
      ctx.fillStyle = foil;
      ctx.beginPath();
      ctx.arc(0, 0, r, 0, TAU);
      ctx.fill();

      var random = seeded(11);
      for (var i = 0; i < 2600; i += 1) {
        var a = random() * TAU;
        var d = Math.sqrt(random()) * r * LID_PRINT;
        ctx.fillStyle = random() > 0.5 ? 'rgba(255,255,255,0.16)' : 'rgba(40,44,50,0.1)';
        ctx.beginPath();
        ctx.ellipse(Math.cos(a) * d, Math.sin(a) * d, r * 0.008 + random() * r * 0.01, r * 0.005 + random() * r * 0.006, random() * Math.PI, 0, TAU);
        ctx.fill();
      }

      var ring = ctx.createRadialGradient(0, 0, r * LID_PRINT, 0, 0, r);
      ring.addColorStop(0, '#9fa4ab');
      ring.addColorStop(0.35, '#f2f3f5');
      ring.addColorStop(1, '#a9aeb5');
      ctx.fillStyle = ring;
      ctx.beginPath();
      ctx.arc(0, 0, r, 0, TAU);
      ctx.arc(0, 0, r * LID_PRINT, 0, TAU, true);
      ctx.fill();
      ctx.lineWidth = size * 0.004;
      ctx.strokeStyle = 'rgba(60,64,70,0.45)';
      ctx.beginPath();
      ctx.arc(0, 0, r * LID_PRINT, 0, TAU);
      ctx.stroke();

      if (logo && logo.naturalWidth) {
        var half = Math.hypot(logo.naturalWidth, logo.naturalHeight) / 2;
        var scale = (r * LOGO_SAFE) / half;
        var w = logo.naturalWidth * scale;
        var h = logo.naturalHeight * scale;
        ctx.save();
        ctx.beginPath();
        ctx.arc(0, 0, r * LID_PRINT, 0, TAU);
        ctx.clip();
        ctx.drawImage(logo, -w / 2, -h / 2, w, h);
        ctx.restore();
      }
      return c;
    }

    function createRenderer(canvas) {
      var ctx = canvas.getContext('2d');
      var quads = buildMesh();
      var state = { color: [0.1, 0.1, 0.1], q: VIEWS.hero, logo: null, lid: null, width: 0, height: 0, dpr: 1 };

      function resize() {
        state.dpr = Math.min(window.devicePixelRatio || 1, 2);
        state.width = Math.round(canvas.clientWidth * state.dpr);
        state.height = Math.round(canvas.clientHeight * state.dpr);
        if (!state.width || !state.height) return false;
        canvas.width = state.width;
        canvas.height = state.height;
        state.lid = buildLid(Math.min(1024, Math.max(256, Math.round(state.width * 0.8))), state.logo);
        return true;
      }

      function draw() {
        if (!state.width && !resize()) return;
        var W = state.width;
        var H = state.height;
        var S = Math.min(W, H) / 2 / EXTENT;
        var cx = W / 2;
        var cy = H / 2;
        var m = qMatrix(state.q);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, W, H);

        var visible = [];
        quads.forEach(function (q) {
          var n = apply(m, q.n[0], q.n[1], q.n[2]);
          if (n[2] <= 0.0005) return;
          var pts = [
            apply(m, q.p[0][0], q.p[0][1], q.p[0][2] - CENTER_Z),
            apply(m, q.p[1][0], q.p[1][1], q.p[1][2] - CENTER_Z),
            apply(m, q.p[2][0], q.p[2][1], q.p[2][2] - CENTER_Z),
            apply(m, q.p[3][0], q.p[3][1], q.p[3][2] - CENTER_Z)
          ];
          visible.push({
            pts: pts,
            nl: apply(m, q.nl[0], q.nl[1], q.nl[2]),
            nr: apply(m, q.nr[0], q.nr[1], q.nr[2]),
            mat: q.mat,
            gl: q.mat === 'rim' ? 0 : q.gl,
            gr: q.mat === 'rim' ? 0 : q.gr,
            depth: (pts[0][2] + pts[1][2] + pts[2][2] + pts[3][2]) / 4
          });
        });
        visible.sort(function (a, b) { return a.depth - b.depth; });

        var body = material(state.color, 'body');
        var rim = material(state.color, 'rim');
        var x = [0, 0, 0, 0];
        var y = [0, 0, 0, 0];
        var bleed = 0.6 * state.dpr;
        visible.forEach(function (f) {
          var mat = f.mat === 'rim' ? rim : body;
          var cl = shade(mat, f.nl, f.gl);
          var cr = shade(mat, f.nr, f.gr);
          var mx = 0;
          var my = 0;
          for (var i = 0; i < 4; i += 1) {
            x[i] = cx + f.pts[i][0] * S;
            y[i] = cy - f.pts[i][1] * S;
            mx += x[i] / 4;
            my += y[i] / 4;
          }
          var fill;
          if (Math.abs(cl[0] - cr[0]) + Math.abs(cl[1] - cr[1]) + Math.abs(cl[2] - cr[2]) > 0.02) {
            fill = ctx.createLinearGradient((x[0] + x[3]) / 2, (y[0] + y[3]) / 2, (x[1] + x[2]) / 2, (y[1] + y[2]) / 2);
            fill.addColorStop(0, rgb(cl));
            fill.addColorStop(1, rgb(cr));
          } else {
            fill = rgb([(cl[0] + cr[0]) / 2, (cl[1] + cr[1]) / 2, (cl[2] + cr[2]) / 2]);
          }
          ctx.fillStyle = fill;
          ctx.beginPath();
          for (var j = 0; j < 4; j += 1) {
            var px = x[j] + (x[j] > mx ? bleed : -bleed);
            var py = y[j] + (y[j] > my ? bleed : -bleed);
            if (j === 0) ctx.moveTo(px, py);
            else ctx.lineTo(px, py);
          }
          ctx.closePath();
          ctx.fill();
        });

        var lidN = apply(m, 0, 0, 1);
        if (lidN[2] > 0.0005 && state.lid) {
          var ex = apply(m, 1, 0, 0);
          var ey = apply(m, 0, 1, 0);
          var o = apply(m, 0, 0, -CENTER_Z);
          ctx.save();
          ctx.setTransform(S * ex[0], -S * ex[1], S * ey[0], -S * ey[1], cx + o[0] * S, cy - o[1] * S);
          ctx.beginPath();
          ctx.arc(0, 0, 1, 0, TAU);
          ctx.clip();
          var size = state.lid.width;
          ctx.save();
          ctx.transform(2 / size, 0, 0, -2 / size, -1, 1);
          ctx.drawImage(state.lid, 0, 0);
          ctx.restore();

          var rz = 2 * lidN[2] * lidN[2] - 1;
          var facing = Math.max(0, 2 * lidN[2] * lidN[0] * KEY[0] + 2 * lidN[2] * lidN[1] * KEY[1] + rz * KEY[2]);
          var light = 0.35 + 0.65 * Math.pow(facing, 1.2);
          var dark = Math.min(0.32, Math.max(0, (0.75 - light) * 0.5));
          if (dark > 0) {
            ctx.fillStyle = 'rgba(12,14,18,' + dark.toFixed(3) + ')';
            ctx.fillRect(-1, -1, 2, 2);
          }
          var sweep = ctx.createLinearGradient(-1, 1, 1, -1);
          var center = Math.min(0.9, Math.max(0.1, 0.5 + lidN[0] * 0.9 - lidN[1] * 0.4));
          sweep.addColorStop(Math.max(0, center - 0.3), 'rgba(255,255,255,0)');
          sweep.addColorStop(center, 'rgba(255,255,255,0.28)');
          sweep.addColorStop(Math.min(1, center + 0.3), 'rgba(255,255,255,0)');
          ctx.fillStyle = sweep;
          ctx.fillRect(-1, -1, 2, 2);
          ctx.restore();
        }
      }

      return {
        resize: function () {
          if (resize()) draw();
        },
        draw: draw,
        setColor: function (rgbColor) {
          state.color = rgbColor;
        },
        getColor: function () {
          return state.color.slice();
        },
        setLogo: function (image) {
          state.logo = image;
          if (state.width) state.lid = buildLid(state.lid ? state.lid.width : 512, image);
        },
        setRotation: function (q) {
          state.q = q;
        },
        getRotation: function () {
          return state.q;
        }
      };
    }

    function setup(root) {
      teardown(root);
      var controller = new AbortController();
      var signal = controller.signal;
      var stage = root.querySelector('[data-mc-studio-stage]');
      var nameOutput = root.querySelector('[data-mc-studio-name]');
      var fileInput = root.querySelector('[data-mc-studio-file]');
      var fileName = root.querySelector('[data-mc-studio-file-name]');
      var reset = root.querySelector('[data-mc-studio-reset]');
      var logo = root.querySelector('.mc-capsule__logo');
      var viewer = root.querySelector('[data-mc-studio-viewer]');
      var canvas = root.querySelector('[data-mc-studio-canvas]');
      var viewsGroup = root.querySelector('[data-mc-studio-views]');
      var viewButtons = root.querySelectorAll('[data-mc-studio-view]');
      var defaultFileLabel = fileName ? fileName.textContent : '';
      var objectUrl = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var renderer = null;
      var frame = 0;
      var colorTween = null;
      var viewTween = null;
      var spin = { x: 0, y: 0 };

      if (canvas && canvas.getContext && canvas.getContext('2d')) {
        renderer = createRenderer(canvas);
        root.classList.add('is-3d');
        if (viewsGroup) viewsGroup.hidden = false;
      }

      function tick(now) {
        frame = 0;
        if (!renderer) return;
        var busy = false;
        if (colorTween) {
          var tc = Math.min(1, (now - colorTween.start) / 360);
          var ec = 1 - Math.pow(1 - tc, 3);
          renderer.setColor(colorTween.from.map(function (v, i) { return v + (colorTween.to[i] - v) * ec; }));
          if (tc < 1) busy = true;
          else colorTween = null;
        }
        if (viewTween) {
          var tv = Math.min(1, (now - viewTween.start) / 650);
          var ev = tv < 0.5 ? 4 * tv * tv * tv : 1 - Math.pow(-2 * tv + 2, 3) / 2;
          renderer.setRotation(qSlerp(viewTween.from, viewTween.to, ev));
          if (tv < 1) busy = true;
          else viewTween = null;
        } else if (!drag && (Math.abs(spin.x) > 0.0004 || Math.abs(spin.y) > 0.0004)) {
          rotateBy(spin.x, spin.y);
          spin.x *= 0.93;
          spin.y *= 0.93;
          busy = true;
        }
        renderer.draw();
        if (busy) request();
      }

      function request() {
        if (!frame) frame = requestAnimationFrame(tick);
      }

      function rotateBy(ax, ay) {
        var q = renderer.getRotation();
        q = qMul(qAxis(0, 1, 0, ay), q);
        q = qMul(qAxis(1, 0, 0, ax), q);
        renderer.setRotation(qNorm(q));
      }

      function markView(name) {
        viewButtons.forEach(function (button) {
          button.setAttribute('aria-pressed', button.getAttribute('data-mc-studio-view') === name ? 'true' : 'false');
        });
      }

      function goTo(name) {
        if (!renderer || !VIEWS[name]) return;
        spin.x = 0;
        spin.y = 0;
        markView(name);
        if (reduceMotion) {
          viewTween = null;
          renderer.setRotation(VIEWS[name]);
        } else {
          viewTween = { from: renderer.getRotation(), to: VIEWS[name], start: performance.now() };
        }
        request();
      }

      function setColor(hex, animate) {
        if (!renderer) return;
        var to = hexToRgb(hex);
        if (!animate || reduceMotion) {
          colorTween = null;
          renderer.setColor(to);
        } else {
          colorTween = { from: renderer.getColor(), to: to, start: performance.now() };
        }
        request();
      }

      var checked = root.querySelector('[data-mc-studio-color]:checked');
      if (checked) setColor(checked.value, false);

      root.querySelectorAll('[data-mc-studio-color]').forEach(function (radio) {
        radio.addEventListener(
          'change',
          function () {
            if (!radio.checked || !stage) return;
            stage.style.setProperty('--mc-capsule-color', radio.value);
            if (nameOutput) nameOutput.textContent = radio.getAttribute('data-label') || '';
            setColor(radio.value, true);
          },
          { signal: signal }
        );
      });

      function clearLogo() {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = null;
        if (logo) logo.removeAttribute('href');
        if (fileInput) fileInput.value = '';
        if (fileName) fileName.textContent = defaultFileLabel;
        if (reset) reset.hidden = true;
        if (renderer) {
          renderer.setLogo(null);
          request();
        }
      }

      if (fileInput) {
        fileInput.addEventListener(
          'change',
          function () {
            var file = fileInput.files && fileInput.files[0];
            if (!file || !/^image\/(png|jpeg|webp)$/.test(file.type)) {
              clearLogo();
              return;
            }
            if (objectUrl) URL.revokeObjectURL(objectUrl);
            objectUrl = URL.createObjectURL(file);
            if (logo) logo.setAttribute('href', objectUrl);
            if (fileName) fileName.textContent = file.name;
            if (reset) reset.hidden = false;
            if (renderer) {
              var image = new Image();
              image.onload = function () {
                if (image.src !== objectUrl) return;
                renderer.setLogo(image);
                request();
              };
              image.src = objectUrl;
            }
          },
          { signal: signal }
        );
      }

      if (reset) {
        reset.addEventListener(
          'click',
          function () {
            clearLogo();
            if (fileInput) fileInput.focus();
          },
          { signal: signal }
        );
      }

      viewButtons.forEach(function (button) {
        button.addEventListener(
          'click',
          function () {
            goTo(button.getAttribute('data-mc-studio-view'));
          },
          { signal: signal }
        );
      });

      var drag = null;

      if (viewer && renderer) {
        var RAD_PER_PX = 0.6 * DEG;
        var KEY_STEP = 12 * DEG;

        var endDrag = function (event) {
          if (!drag || event.pointerId !== drag.id) return;
          if (viewer.hasPointerCapture(drag.id)) viewer.releasePointerCapture(drag.id);
          if (reduceMotion || performance.now() - drag.time > 80) {
            spin.x = 0;
            spin.y = 0;
          }
          drag = null;
          viewer.classList.remove('is-dragging');
          request();
        };

        viewer.addEventListener(
          'pointerdown',
          function (event) {
            if (event.button !== 0) return;
            drag = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now() };
            viewTween = null;
            spin.x = 0;
            spin.y = 0;
            markView('');
            viewer.setPointerCapture(event.pointerId);
            viewer.classList.add('is-dragging');
          },
          { signal: signal }
        );

        viewer.addEventListener(
          'pointermove',
          function (event) {
            if (!drag || event.pointerId !== drag.id) return;
            var ax = (event.clientY - drag.y) * RAD_PER_PX;
            var ay = (event.clientX - drag.x) * RAD_PER_PX;
            drag.x = event.clientX;
            drag.y = event.clientY;
            drag.time = performance.now();
            rotateBy(ax, ay);
            spin.x = ax;
            spin.y = ay;
            request();
          },
          { signal: signal }
        );

        viewer.addEventListener('pointerup', endDrag, { signal: signal });
        viewer.addEventListener('pointercancel', endDrag, { signal: signal });
        viewer.addEventListener('lostpointercapture', endDrag, { signal: signal });
        viewer.addEventListener('dragstart', function (event) { event.preventDefault(); }, { signal: signal });

        viewer.addEventListener(
          'keydown',
          function (event) {
            switch (event.key) {
              case 'ArrowLeft':
                rotateBy(0, -KEY_STEP);
                break;
              case 'ArrowRight':
                rotateBy(0, KEY_STEP);
                break;
              case 'ArrowUp':
                rotateBy(-KEY_STEP, 0);
                break;
              case 'ArrowDown':
                rotateBy(KEY_STEP, 0);
                break;
              case 'Home':
                goTo('hero');
                event.preventDefault();
                return;
              default:
                return;
            }
            viewTween = null;
            markView('');
            event.preventDefault();
            request();
          },
          { signal: signal }
        );

        viewer.addEventListener('dblclick', function () { goTo('hero'); }, { signal: signal });

        if ('ResizeObserver' in window) {
          var observer = new ResizeObserver(function () { renderer.resize(); });
          observer.observe(canvas);
          signal.addEventListener('abort', function () { observer.disconnect(); });
        } else {
          window.addEventListener('resize', function () { renderer.resize(); }, { signal: signal });
        }
        renderer.resize();
      }

      signal.addEventListener('abort', function () {
        if (frame) cancelAnimationFrame(frame);
        root.classList.remove('is-3d');
      });

      instances.set(root, function () {
        controller.abort();
        if (objectUrl) URL.revokeObjectURL(objectUrl);
      });
    }

    function teardown(root) {
      var destroy = instances.get(root);
      if (destroy) {
        destroy();
        instances.delete(root);
      }
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-mc-studio]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-mc-studio]').forEach(teardown);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-cart-drawer"]) return;
  try {
    
  if (!customElements.get('mc-cart-drawer')) {
    class McCartDrawer extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.dialog = this.querySelector('[data-mc-cd-dialog]');
        this.live = this.querySelector('[data-mc-cd-live]');
        this.livePage = this.querySelector('[data-mc-cd-live-page]');
        this.notice = this.querySelector('[data-mc-cd-notice]');
        this.errorBox = this.querySelector('[data-mc-cd-error]');
        this.sectionId = this.dataset.sectionId;
        this.queue = Promise.resolve();
        this.busy = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        window.Montecapra = window.Montecapra || {};
        window.Montecapra.cart = {
          open: (opener) => this.open(opener),
          close: () => this.close(),
          add: (payload, options) => this.add(payload, options),
          refresh: () => this.refresh(),
        };

        const on = (target, type, handler) => target.addEventListener(type, handler, { signal: this.abort.signal });
        on(this.dialog, 'click', (event) => this.onClick(event));
        on(this.dialog, 'cancel', (event) => {
          event.preventDefault();
          this.close();
        });
        on(this.dialog, 'close', () => this.afterClose());
        on(this.dialog, 'submit', (event) => this.onSubmit(event));
        on(document, 'click', (event) => this.onDocumentClick(event));
        if (this.notice) {
          on(this.notice, 'click', () => {
            this.hideNotice(true);
            this.open(this.trigger());
          });
          // The timer pauses while the notice is hovered or focused so it can still be reached.
          on(this.notice, 'mouseenter', () => clearTimeout(this.noticeTimer));
          on(this.notice, 'focusin', () => clearTimeout(this.noticeTimer));
          on(this.notice, 'mouseleave', () => this.scheduleNoticeHide());
          on(this.notice, 'focusout', () => this.scheduleNoticeHide());
          on(this.notice, 'keydown', (event) => {
            if (event.key === 'Escape') this.hideNotice(true);
          });
          on(window, 'scroll', () => this.placeNotice());
          on(window, 'resize', () => this.placeNotice());
        }
        on(document, 'shopify:section:select', (event) => {
          if (event.detail.sectionId === this.sectionId) this.open();
        });
        on(document, 'shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.sectionId) this.close();
        });
        on(window, 'pageshow', (event) => {
          if (event.persisted) this.refresh();
        });

        const trigger = this.trigger();
        if (trigger) {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-expanded', 'false');
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        clearTimeout(this.closeTimer);
        clearTimeout(this.noticeTimer);
        document.documentElement.classList.remove('mc-cd-lock');
      }

      get root() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      trigger() {
        return document.getElementById('cart-icon-bubble');
      }

      onDocumentClick(event) {
        const trigger = event.target.closest('#cart-icon-bubble');
        if (!trigger || event.defaultPrevented) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const main = document.getElementById('MainContent');
        if (main && main.dataset.template === 'cart') return;
        event.preventDefault();
        this.open(trigger);
      }

      open(opener) {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
          this.dialog.classList.add('is-open');
          return;
        }
        if (this.dialog.open) return;
        this.hideNotice(true);
        this.opener = opener || document.activeElement;
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--mc-cd-scrollbar', `${Math.max(0, scrollbar)}px`);
        document.documentElement.classList.add('mc-cd-lock');
        this.dialog.showModal();
        this.dialog.querySelector('[data-mc-cd-close]').focus({ preventScroll: true });
        requestAnimationFrame(() => this.dialog.classList.add('is-open'));
        const trigger = this.trigger();
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      close() {
        if (!this.dialog.open || this.closeTimer) return;
        this.dialog.classList.remove('is-open');
        const duration = this.reduceMotion.matches ? 0 : 320;
        this.closeTimer = setTimeout(() => this.dialog.close(), duration);
      }

      // Also runs when the browser closes the dialog on its own (repeated Escape skips the cancel event).
      afterClose() {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.dialog.classList.remove('is-open');
        document.documentElement.classList.remove('mc-cd-lock');
        const trigger = this.trigger();
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        const target = this.opener && this.opener.isConnected ? this.opener : trigger;
        if (target) target.focus({ preventScroll: true });
        this.opener = null;
      }

      onClick(event) {
        if (event.target === this.dialog) {
          this.close();
          return;
        }
        const close = event.target.closest('[data-mc-cd-close]');
        if (close) {
          this.close();
          return;
        }
        // busy is set before the queued request starts so repeated taps in the same frame are ignored.
        const change = event.target.closest('[data-mc-cd-change]');
        if (change) {
          if (change.disabled || this.busy) return;
          this.busy = true;
          this.change(change.dataset.mcCdChange, Number(change.dataset.quantity), change);
          return;
        }
        const add = event.target.closest('[data-mc-cd-add]');
        if (add) {
          if (this.busy) return;
          this.busy = true;
          this.add([{ id: Number(add.dataset.mcCdAdd), quantity: 1 }], { opener: this.opener }).catch(() => {});
        }
      }

      onSubmit(event) {
        const form = event.target;
        if (!form.matches('[data-mc-cd-checkout-form]')) return;
        const button = form.querySelector('[data-mc-cd-checkout]');
        if (this.busy || button.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        button.setAttribute('aria-disabled', 'true');
        const discount = form.querySelector('[data-mc-cd-discount]');
        const code = discount ? discount.value.trim() : '';
        if (code) {
          event.preventDefault();
          window.location.href = `${this.root}checkout?discount=${encodeURIComponent(code)}`;
        }
        window.addEventListener('pageshow', () => button.removeAttribute('aria-disabled'), { once: true });
      }

      enqueue(task) {
        const run = this.queue.then(task, task);
        this.queue = run.catch(() => {});
        return run;
      }

      setBusy(busy, line) {
        this.busy = busy;
        if (busy) this.dialog.setAttribute('aria-busy', 'true');
        else this.dialog.removeAttribute('aria-busy');
        if (line) line.classList.toggle('is-busy', busy);
      }

      showError(message) {
        if (!this.errorBox) return;
        this.errorBox.textContent = message || '';
        this.errorBox.hidden = !message;
      }

      announce(message) {
        const live = this.dialog.open ? this.live : this.livePage;
        if (!live) return;
        live.textContent = '';
        window.setTimeout(() => {
          live.textContent = message;
        }, 60);
      }

      // After an add the drawer stays closed: the header count updates and this notice offers to open it.
      afterAdd() {
        if (this.dialog.open) {
          this.announce(this.dataset.textAdded);
          return;
        }
        this.showNotice();
        this.announce(`${this.dataset.textAdded} ${this.notice ? this.notice.textContent.trim() : ''}`.trim());
      }

      showNotice() {
        if (!this.notice) return;
        clearTimeout(this.noticeTimer);
        clearTimeout(this.noticeHideTimer);
        this.notice.hidden = false;
        this.placeNotice();
        requestAnimationFrame(() => this.notice.classList.add('is-visible'));
        this.scheduleNoticeHide();
      }

      scheduleNoticeHide() {
        clearTimeout(this.noticeTimer);
        if (!this.notice || this.notice.hidden) return;
        this.noticeTimer = setTimeout(() => this.hideNotice(), 4000);
      }

      hideNotice(immediate) {
        if (!this.notice || this.notice.hidden) return;
        clearTimeout(this.noticeTimer);
        clearTimeout(this.noticeHideTimer);
        this.notice.classList.remove('is-visible');
        const duration = immediate || this.reduceMotion.matches ? 0 : 240;
        this.noticeHideTimer = setTimeout(() => {
          this.notice.hidden = true;
        }, duration);
      }

      placeNotice() {
        if (!this.notice || this.notice.hidden) return;
        const viewport = document.documentElement.clientWidth;
        const trigger = this.trigger();
        const rect = trigger ? trigger.getBoundingClientRect() : null;
        const visible = rect && rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        // Below the whole header so the logo and navigation links stay uncovered.
        const header = trigger ? trigger.closest('header') : null;
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        const top = visible ? Math.max(rect.bottom, headerBottom) + 8 : 12;
        const right = visible ? Math.max(8, viewport - rect.right - 4) : 12;
        this.notice.style.setProperty('--mc-cd-notice-top', `${Math.round(top)}px`);
        this.notice.style.setProperty('--mc-cd-notice-right', `${Math.round(right)}px`);
        if (visible) {
          const box = this.notice.getBoundingClientRect();
          const arrow = viewport - right - (rect.left + rect.width / 2) - 5;
          this.notice.style.setProperty('--mc-cd-notice-arrow', `${Math.round(Math.min(Math.max(arrow, 12), box.width - 22))}px`);
        }
        this.notice.classList.toggle('is-floating', !visible);
      }

      sectionsParam() {
        return [this.sectionId, 'cart-icon-bubble'];
      }

      async request(path, body, isForm) {
        let response;
        try {
          response = await fetch(`${this.root}${path}`, {
            method: 'POST',
            headers: isForm
              ? { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
              : { 'Content-Type': 'application/json', Accept: 'application/json' },
            body,
          });
        } catch (error) {
          const networkError = new Error(this.dataset.textNetwork);
          networkError.network = true;
          throw networkError;
        }
        let data = {};
        try {
          data = await response.json();
        } catch (error) {
          data = {};
        }
        if (!response.ok || data.status) {
          const detail = data.description || data.message;
          throw new Error(typeof detail === 'string' && detail ? detail : this.dataset.textError);
        }
        return data;
      }

      add(payload, options = {}) {
        return this.enqueue(async () => {
          this.setBusy(true);
          this.showError('');
          try {
            let body;
            const isForm = payload instanceof FormData;
            if (isForm) {
              body = payload;
              body.append('sections', this.sectionsParam().join(','));
              body.append('sections_url', window.location.pathname);
            } else {
              body = JSON.stringify({ items: payload, sections: this.sectionsParam(), sections_url: window.location.pathname });
            }
            const data = await this.request('cart/add.js', body, isForm);
            this.render(data.sections);
            this.publish(data);
            this.afterAdd();
            return data;
          } catch (error) {
            // A stock rejection can still add the available units, so the cart is reloaded.
            if (!error.network) await this.refresh();
            this.hideNotice(true);
            if (this.dialog.open) this.showError(error.message);
            throw error;
          } finally {
            this.setBusy(false);
          }
        });
      }

      change(key, quantity, trigger) {
        if (Number(quantity) === 0) window.MontecapraAutoMug?.markManualRemoval?.(key);
        return this.enqueue(async () => {
          const line = trigger ? trigger.closest('[data-mc-cd-line]') : null;
          this.setBusy(true, line);
          this.showError('');
          try {
            const body = JSON.stringify({ id: key, quantity, sections: this.sectionsParam(), sections_url: window.location.pathname });
            const data = await this.request('cart/change.js', body, false);
            this.render(data.sections, trigger);
            this.publish(data);
            this.announce(quantity === 0 ? this.dataset.textRemoved : this.dataset.textUpdated);
          } catch (error) {
            this.showError(error.message);
            this.announce(error.message);
            await this.refresh();
          } finally {
            this.setBusy(false, line);
          }
        }).catch(() => {});
      }

      async refresh() {
        try {
          const response = await fetch(`${this.root}?sections=${this.sectionsParam().join(',')}`);
          if (!response.ok) return;
          this.render(await response.json());
        } catch (error) {
          this.showError(this.dataset.textNetwork);
        }
      }

      render(sections, trigger) {
        if (!sections) return;
        const html = sections[this.sectionId];
        if (html) {
          const focusKey = trigger ? trigger.dataset.mcCdFocus : document.activeElement && this.contains(document.activeElement) ? document.activeElement.dataset.mcCdFocus : null;
          const fresh = new DOMParser().parseFromString(html, 'text/html');
          this.querySelectorAll('[data-mc-cd-region]').forEach((region) => {
            const next = fresh.querySelector(`[data-mc-cd-region="${region.dataset.mcCdRegion}"]`);
            if (next) region.innerHTML = next.innerHTML;
          });
          const footer = this.querySelector('[data-mc-cd-checkout-form]');
          const freshFooter = fresh.querySelector('[data-mc-cd-checkout-form]');
          if (footer && freshFooter) footer.hidden = freshFooter.hidden;
          if (focusKey) this.restoreFocus(focusKey);
        }
        const bubbleHtml = sections['cart-icon-bubble'];
        const bubble = this.trigger();
        if (bubbleHtml && bubble) {
          const fresh = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        }
      }

      restoreFocus(focusKey) {
        const find = (key) => this.querySelector(`[data-mc-cd-focus="${CSS.escape(key)}"]`);
        let target = find(focusKey);
        if (target && target.disabled) {
          target = find(focusKey.replace(/^(minus|plus)-/, 'qty-'));
        }
        if (!target) target = find('title');
        if (target && this.dialog.open) target.focus({ preventScroll: true });
      }

      publish(data) {
        window.MontecapraAutoMug?.schedule();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mc-cart-drawer', cartData: data });
        }
      }

      // Dawn's product-form.js talks to the cart element through these three methods.
      getSectionsToRender() {
        return this.sectionsParam().map((id) => ({ id }));
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      renderContents(parsedState) {
        window.MontecapraAutoMug?.schedule();
        this.render(parsedState.sections);
        this.afterAdd();
      }
    }

    customElements.define('mc-cart-drawer', McCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-hero-premium"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-hero-video')) {
    class MontecapraHeroVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-hp-video-toggle]');
        if (!this.video || !this.toggle) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onToggle = () => this.setPaused(!this.video.paused);
        this.toggle.addEventListener('click', this.onToggle);
        if (this.reducedMotion.matches) this.setPaused(true);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
      }

      setPaused(paused) {
        if (paused) {
          this.video.pause();
        } else {
          this.video.play().catch(() => {});
        }
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      }
    }

    customElements.define('mc-hero-video', MontecapraHeroVideo);
  }

  if (!customElements.get('mc-hero-sequence')) {
    /*
     * Plays a frame sequence on a canvas over the first frame, which stays as the LCP image.
     * Frames download only after the page has loaded; reduced motion keeps the first frame.
     */
    class MontecapraHeroSequence extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.canvas = this.querySelector('canvas');
        this.context = this.canvas ? this.canvas.getContext('2d') : null;
        if (!this.context) return;

        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const source = (mobile ? this.dataset.framesMobile : this.dataset.frames) || '';
        this.urls = source.split('|').filter(Boolean);
        if (this.urls.length < 2) return;

        this.fps = Math.min(30, Math.max(6, Number(this.dataset.fps) || 24));
        this.playback = this.dataset.playback || 'once';
        this.current = -1;

        this.onResize = () => this.resize();
        this.onScroll = () => this.requestScrollFrame();
        this.start = () => {
          const idle = window.requestIdleCallback || ((callback) => setTimeout(callback, 1));
          idle(() => this.load(), { timeout: 2000 });
        };

        if (document.readyState === 'complete') {
          this.start();
        } else {
          window.addEventListener('load', this.start, { once: true });
        }
      }

      disconnectedCallback() {
        window.removeEventListener('load', this.start);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
        cancelAnimationFrame(this.frameRequest);
        this.disconnected = true;
      }

      load() {
        this.images = this.urls.map((url) => {
          const image = new Image();
          image.decoding = 'async';
          image.src = url;
          return image;
        });

        Promise.all(this.images.map((image) => image.decode().catch(() => null))).then(() => {
          if (this.disconnected) return;
          this.images = this.images.filter((image) => image.naturalWidth > 0);
          if (this.images.length < 2) return;

          this.resize();
          window.addEventListener('resize', this.onResize, { passive: true });
          this.draw(0);
          this.classList.add('is-ready');

          if (this.playback === 'scroll') {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.requestScrollFrame();
          } else {
            this.playOnce();
          }
        });
      }

      resize() {
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.round(this.clientWidth * ratio);
        this.canvas.height = Math.round(this.clientHeight * ratio);
        if (this.current > -1) {
          const index = this.current;
          this.current = -1;
          this.draw(index);
        }
      }

      draw(index) {
        if (index === this.current) return;
        const image = this.images[index];
        if (!image) return;

        const { width, height } = this.canvas;
        const styles = getComputedStyle(this);
        const contain = styles.getPropertyValue('--hp-fit').trim() === 'contain';
        const fit = contain ? Math.min : Math.max;
        const scale = fit(width / image.naturalWidth, height / image.naturalHeight);
        const drawWidth = image.naturalWidth * scale;
        const drawHeight = image.naturalHeight * scale;
        let focalProperty = '--hero-focal-mobile';
        if (window.matchMedia('(min-width: 990px)').matches) focalProperty = '--hero-focal-desktop';
        else if (window.matchMedia('(min-width: 750px)').matches) focalProperty = '--hero-focal';
        const focal = contain ? '50% 50%' : styles.getPropertyValue(focalProperty).trim() || '50% 50%';
        const [x = '50%', y = '50%'] = focal.split(/\s+/);
        const offsetX = (width - drawWidth) * (parseFloat(x) / 100);
        const offsetY = (height - drawHeight) * (parseFloat(y) / 100);

        if (contain) this.context.clearRect(0, 0, width, height);
        this.context.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
        this.current = index;
      }

      playOnce() {
        const interval = 1000 / this.fps;
        let last = performance.now();
        let index = 0;

        const step = (now) => {
          if (this.disconnected) return;
          if (now - last >= interval) {
            last = now;
            index += 1;
            this.draw(index);
          }
          if (index < this.images.length - 1) this.frameRequest = requestAnimationFrame(step);
        };

        this.frameRequest = requestAnimationFrame(step);
      }

      requestScrollFrame() {
        cancelAnimationFrame(this.frameRequest);
        this.frameRequest = requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect();
          const progress = Math.min(1, Math.max(0, -rect.top / Math.max(1, rect.height)));
          this.draw(Math.round(progress * (this.images.length - 1)));
        });
      }
    }

    customElements.define('mc-hero-sequence', MontecapraHeroSequence);
  }

  if (!customElements.get('mc-hero-carousel')) {
    /*
     * Arrows, dots and keys drive a native scroll-snap track, so swipe stays native on touch.
     * Autoplay only runs when enabled, never under reduced motion, and stops for good on any interaction.
     */
    class MontecapraHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hp-track]');
        this.slides = Array.from(this.querySelectorAll('[data-hp-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-hp-dot]'));
        this.prevButton = this.querySelector('[data-hp-prev]');
        this.nextButton = this.querySelector('[data-hp-next]');
        this.autoplayButton = this.querySelector('[data-hp-autoplay]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;

        this.onPrev = () => this.interact(() => this.goTo(this.index - 1));
        this.onNext = () => this.interact(() => this.goTo(this.index + 1));
        this.onDot = (event) => this.interact(() => this.goTo(Number(event.currentTarget.dataset.hpDot)));
        this.onScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.sync());
        };
        this.onKeydown = (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.interact(() => this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1)));
          }
        };
        this.onPointerDown = () => this.stopAutoplay();
        this.onAutoplayToggle = () => (this.autoplayActive ? this.stopAutoplay() : this.startAutoplay());
        this.onPause = () => this.clearTimer();
        this.onResume = () => {
          if (this.autoplayActive && !this.matches(':hover') && !this.contains(document.activeElement)) this.schedule();
        };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest?.('[data-hp-slide]');
          const index = this.slides.indexOf(slide);
          if (index < 0) return;
          this.stopAutoplay();
          this.goTo(index, true);
        };
        this.onLoad = () => {
          this.loaded = true;
          this.warm(this.index);
        };

        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDot));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKeydown);
        this.track.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.autoplayButton?.addEventListener('click', this.onAutoplayToggle);
        this.addEventListener('mouseenter', this.onPause);
        this.addEventListener('mouseleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        if (document.readyState === 'complete') this.onLoad();
        else window.addEventListener('load', this.onLoad, { once: true });

        this.sync();
        const delay = Number(this.dataset.autoplay) || 0;
        if (delay > 0 && !this.reducedMotion.matches && !window.Shopify?.designMode) {
          this.delay = delay;
          this.startAutoplay();
        } else {
          this.autoplayButton?.setAttribute('hidden', '');
        }
      }

      disconnectedCallback() {
        this.clearTimer();
        cancelAnimationFrame(this.scrollFrame);
        window.removeEventListener('load', this.onLoad);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      interact(action) {
        this.stopAutoplay();
        action();
      }

      goTo(index, instant = false) {
        const count = this.slides.length;
        const target = ((index % count) + count) % count;
        const smooth = !instant && !this.reducedMotion.matches;
        this.warm(target);
        this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }

      sync() {
        const width = this.track.clientWidth || 1;
        const index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / width)));
        if (index === this.index && this.synced) return;
        this.index = index;
        this.synced = true;
        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        if (this.loaded) this.warm(index);
      }

      /* Neighbours load ahead of time so a swipe never reveals an empty slide. */
      warm(index) {
        const count = this.slides.length;
        [index, index + 1, index - 1].forEach((i) => {
          const image = this.slides[((i % count) + count) % count].querySelector('img');
          if (image && image.loading === 'lazy') image.loading = 'eager';
        });
      }

      startAutoplay() {
        if (!this.delay || this.reducedMotion.matches) return;
        this.autoplayActive = true;
        this.autoplayButton?.setAttribute('aria-pressed', 'false');
        this.autoplayButton?.setAttribute('aria-label', this.autoplayButton.dataset.labelPause);
        this.schedule();
      }

      stopAutoplay() {
        this.autoplayActive = false;
        this.clearTimer();
        this.autoplayButton?.setAttribute('aria-pressed', 'true');
        this.autoplayButton?.setAttribute('aria-label', this.autoplayButton.dataset.labelPlay);
      }

      schedule() {
        this.clearTimer();
        this.timer = setTimeout(() => {
          this.timer = null;
          if (!this.autoplayActive) return;
          this.goTo(this.index + 1);
          this.schedule();
        }, this.delay);
      }

      clearTimer() {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    customElements.define('mc-hero-carousel', MontecapraHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-page-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function focusStatus() {
      var status = document.querySelector('[data-mc-form-status]');
      if (status) status.focus({ preventScroll: false });
    }
    function showProjectHint(select) {
      var hint = document.getElementById(select.getAttribute('aria-describedby'));
      if (!hint) return;
      var option = select.options[select.selectedIndex];
      var text = (option && option.getAttribute('data-hint')) || '';
      hint.textContent = text;
      hint.hidden = !text;
    }
    document.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('[data-mc-form-project]')) showProjectHint(event.target);
    });
    function init() {
      focusStatus();
      document.querySelectorAll('[data-mc-form-project]').forEach(showProjectHint);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-page-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = new Map();
    var desktop = window.matchMedia('(min-width: 990px)');

    function setup(root) {
      teardown(root);
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-mc-journey-step]'));
      var frames = Array.prototype.slice.call(root.querySelectorAll('[data-mc-journey-frame]'));
      if (!steps.length || !('IntersectionObserver' in window)) return;

      var current = root.querySelector('[data-mc-journey-current]');
      var fill = root.querySelector('[data-mc-journey-fill]');
      var total = steps.length;

      function activate(index) {
        steps.forEach(function (step, i) {
          step.classList.toggle('is-active', i === index);
        });
        frames.forEach(function (frame, i) {
          var active = i === index;
          frame.classList.toggle('is-active', active);
          if (active) frame.removeAttribute('aria-hidden');
          else frame.setAttribute('aria-hidden', 'true');
        });
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        if (fill) fill.style.setProperty('--mc-journey-progress', String((index + 1) / total));
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) activate(Number(entry.target.getAttribute('data-mc-journey-step')) || 0);
          });
        },
        { rootMargin: '-45% 0px -45% 0px' }
      );
      steps.forEach(function (step) {
        observer.observe(step);
      });

      function syncLayout() {
        root.classList.toggle('is-ready', desktop.matches);
      }
      syncLayout();
      desktop.addEventListener('change', syncLayout);

      function onSelect(event) {
        var index = steps.findIndex(function (step) {
          return step.contains(event.target);
        });
        if (index > -1) activate(index);
      }
      document.addEventListener('shopify:block:select', onSelect);

      instances.set(root, function () {
        observer.disconnect();
        desktop.removeEventListener('change', syncLayout);
        document.removeEventListener('shopify:block:select', onSelect);
        root.classList.remove('is-ready');
      });
    }

    function teardown(root) {
      var destroy = instances.get(root);
      if (destroy) {
        destroy();
        instances.delete(root);
      }
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-mc-journey]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-mc-journey]').forEach(teardown);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-product"]) return;
  try {
    
  if (!customElements.get('mc-product-page')) {
    class McProductPage extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.observers = [];
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.add('mc-pdp--js');
        const addButton = this.querySelector('[data-mc-pdp-add]');
        this.variantAvailable = addButton ? !addButton.disabled : true;
        const variantsData = this.querySelector('[data-mc-pdp-variants]');
        try {
          this.variants = JSON.parse(variantsData ? variantsData.textContent : '[]');
        } catch (error) {
          this.variants = [];
        }
        this.initGallery();
        this.initLightbox();
        this.initQuantity();
        this.initVariants();
        this.initForm();
        this.initPairing();
        this.initSticky();
        this.initReveal();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.observers.forEach((observer) => observer.disconnect());
        this.observers = [];
      }

      on(target, type, handler) {
        if (target) target.addEventListener(type, handler, { signal: this.abort.signal });
      }

      initGallery() {
        this.track = this.querySelector('[data-mc-gallery-track]');
        this.slides = Array.from(this.querySelectorAll('[data-mc-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-mc-thumb]'));
        this.counter = this.querySelector('[data-mc-gallery-current]');
        this.active = 0;
        if (!this.track || this.slides.length < 2) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => observer.observe(slide));
        this.observers.push(observer);

        this.thumbs.forEach((thumb, index) => this.on(thumb, 'click', () => this.goTo(index)));
        this.querySelectorAll('[data-mc-gallery-step]').forEach((button) => {
          this.on(button, 'click', () => this.goTo(this.active + Number(button.dataset.mcGalleryStep)));
        });
        this.on(this.track, 'keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.active + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.active - 1);
          }
        });
      }

      goTo(index) {
        const total = this.slides.length;
        if (!total) return;
        const target = ((index % total) + total) % total;
        this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        this.setActive(target);
      }

      setActive(index) {
        if (index < 0) return;
        this.active = index;
        if (this.counter) this.counter.textContent = String(index + 1);
        this.thumbs.forEach((thumb, i) => {
          if (i === index) {
            thumb.setAttribute('aria-current', 'true');
            thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      initLightbox() {
        this.dialog = this.querySelector('[data-mc-lightbox]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.lightboxImage = this.dialog.querySelector('[data-mc-lightbox-img]');
        this.lightboxFigure = this.dialog.querySelector('[data-mc-lightbox-figure]');
        this.lightboxCounter = this.dialog.querySelector('[data-mc-lightbox-counter]');
        this.zoomButton = this.dialog.querySelector('[data-mc-lightbox-zoom]');

        this.querySelectorAll('[data-mc-zoom-open]').forEach((button) => {
          this.on(button, 'click', () => this.openLightbox(Number(button.dataset.mcZoomOpen), button));
        });
        this.on(this.dialog.querySelector('[data-mc-lightbox-close]'), 'click', () => this.dialog.close());
        this.dialog.querySelectorAll('[data-mc-lightbox-step]').forEach((button) => {
          this.on(button, 'click', () => this.showInLightbox(this.lightboxIndex + Number(button.dataset.mcLightboxStep)));
        });
        this.on(this.zoomButton, 'click', () => this.setZoom(!this.zoomed));
        this.on(this.lightboxImage, 'click', (event) => this.setZoom(!this.zoomed, event));
        this.on(this.lightboxImage, 'pointermove', (event) => {
          if (this.zoomed && event.pointerType === 'mouse') this.panTo(event);
        });
        this.on(this.dialog, 'keydown', (event) => {
          if (event.key === 'ArrowRight') this.showInLightbox(this.lightboxIndex + 1);
          if (event.key === 'ArrowLeft') this.showInLightbox(this.lightboxIndex - 1);
        });
        this.on(this.dialog, 'click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.on(this.dialog, 'close', () => {
          this.setZoom(false);
          if (this.slides.length > 1) this.goTo(this.lightboxIndex);
          if (this.lightboxReturn) this.lightboxReturn.focus({ preventScroll: true });
        });
      }

      openLightbox(index, trigger) {
        this.lightboxReturn = trigger;
        this.showInLightbox(index);
        this.dialog.showModal();
      }

      showInLightbox(index) {
        const total = this.slides.length;
        if (!total) return;
        const target = ((index % total) + total) % total;
        const slide = this.slides[target];
        this.lightboxIndex = target;
        this.setZoom(false);
        this.lightboxImage.loading = 'eager';
        this.lightboxImage.src = slide.dataset.zoomSrc;
        this.lightboxImage.width = Number(slide.dataset.zoomWidth) || this.lightboxImage.width;
        this.lightboxImage.height = Number(slide.dataset.zoomHeight) || this.lightboxImage.height;
        this.lightboxImage.alt = slide.dataset.zoomAlt || '';
        if (this.lightboxCounter) {
          this.lightboxCounter.textContent = (this.dataset.textCounter || '[current] / [total]')
            .replace('[current]', String(target + 1))
            .replace('[total]', String(total));
        }
      }

      setZoom(on, event) {
        this.zoomed = on;
        if (!this.lightboxImage) return;
        this.lightboxImage.classList.toggle('is-zoomed', on);
        if (this.zoomButton) this.zoomButton.setAttribute('aria-pressed', String(on));
        if (on && event) this.panTo(event);
        if (!on) this.lightboxImage.style.transformOrigin = '';
      }

      panTo(event) {
        const rect = this.lightboxFigure.getBoundingClientRect();
        const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
        const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
        this.lightboxImage.style.transformOrigin = `${x}% ${y}%`;
      }

      initQuantity() {
        this.quantityInput = this.querySelector('[data-mc-pdp-qty-input]');
        if (!this.quantityInput) return;
        this.perBox = Number(this.dataset.perBox) || 0;
        this.unitCents = Number(this.dataset.priceCents) || 0;
        this.boxOptions = Array.from(this.querySelectorAll('[data-mc-pdp-boxes]'));
        this.querySelectorAll('[data-mc-pdp-qty]').forEach((button) => {
          this.on(button, 'click', () => {
            this.setQuantity((parseInt(this.quantityInput.value, 10) || 1) + Number(button.dataset.mcPdpQty));
          });
        });
        this.boxOptions.forEach((option) => {
          this.on(option, 'click', () => this.setQuantity(Number(option.dataset.mcPdpBoxes)));
        });
        this.on(this.quantityInput, 'change', () => this.setQuantity(parseInt(this.quantityInput.value, 10) || 1));
        this.setQuantity(1);
      }

      setQuantity(value) {
        const max = Number(this.quantityInput.max) || Infinity;
        const next = Math.min(max, Math.max(1, value));
        this.quantityInput.value = String(next);
        const [minus, plus] = this.querySelectorAll('[data-mc-pdp-qty]');
        if (minus) minus.disabled = next <= 1;
        if (plus) plus.disabled = next >= max;
        this.boxOptions.forEach((option) => {
          const boxes = Number(option.dataset.mcPdpBoxes);
          option.setAttribute('aria-pressed', String(boxes === next));
          option.disabled = boxes > max;
        });
        this.updateTotal();
      }

      updateTotal() {
        if (!this.perBox || !this.quantityInput) return;
        const boxes = parseInt(this.quantityInput.value, 10) || 1;
        const capsules = String(boxes * this.perBox);
        const total = this.formatMoney(this.unitCents * boxes);
        const unit = this.formatMoney(this.unitCents);
        this.querySelectorAll('[data-mc-pdp-total]').forEach((node) => {
          node.textContent = total;
        });
        this.querySelectorAll('[data-mc-pdp-capsules-text]').forEach((node) => {
          node.textContent = (this.dataset.textCapsules || '[capsules]').replace('[capsules]', capsules);
        });
        const detail = this.querySelector('[data-mc-pdp-total-detail]');
        if (detail) {
          detail.textContent = (this.dataset.textTotalDetail || '')
            .replace('[capsules]', capsules)
            .replace('[price]', unit);
        }
      }

      // Mirrors Liquid's money_without_trailing_zeros for the shop's money format.
      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '';
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const kind = match ? match[1] : 'amount';
        let thousands = ',';
        let decimal = '.';
        if (kind.includes('comma_separator')) {
          thousands = '.';
          decimal = ',';
        } else if (kind.includes('apostrophe_separator')) {
          thousands = "'";
        } else if (kind.includes('period_and_space_separator')) {
          thousands = ' ';
        } else if (kind.includes('space_separator')) {
          thousands = ' ';
          decimal = ',';
        }
        const [whole, fraction] = (Math.max(0, cents) / 100).toFixed(kind.includes('no_decimals') ? 0 : 2).split('.');
        let amount = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        if (fraction && Number(fraction) !== 0) amount += decimal + fraction;
        return match ? format.replace(match[0], amount) : `$${amount}`;
      }

      initVariants() {
        const select = this.querySelector('[data-mc-pdp-variant]');
        if (!select) return;
        this.on(select, 'change', () => this.applyVariant(Number(select.value)));
      }

      applyVariant(id) {
        const variant = this.variants.find((item) => item.id === id);
        if (!variant) return;
        this.variantAvailable = variant.available;
        if (typeof variant.price_cents === 'number') this.unitCents = variant.price_cents;
        this.querySelectorAll('[data-mc-pdp-price]').forEach((node) => {
          node.textContent = variant.price;
        });
        const compare = this.querySelector('[data-mc-pdp-compare]');
        if (compare) {
          compare.textContent = variant.compare || '';
          compare.hidden = !variant.compare;
        }
        const stock = this.querySelector('[data-mc-pdp-stock]');
        if (stock) {
          stock.dataset.state = variant.available ? 'in' : 'out';
          stock.querySelector('[data-mc-pdp-stock-text]').textContent = variant.available ? this.dataset.textInStock : this.dataset.textSoldOut;
        }
        this.querySelectorAll('[data-mc-pdp-add]').forEach((button) => {
          button.disabled = !variant.available;
          button.querySelector('[data-mc-pdp-add-label]').textContent = variant.available ? this.dataset.textAdd : this.dataset.textSoldOut;
        });
        if (this.quantityInput) {
          if (variant.max) this.quantityInput.max = String(variant.max);
          else this.quantityInput.removeAttribute('max');
          this.setQuantity(parseInt(this.quantityInput.value, 10) || 1);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
        if (variant.media) {
          const index = this.slides.findIndex((slide) => Number(slide.dataset.mediaId) === variant.media);
          if (index >= 0) this.goTo(index);
        }
      }

      initForm() {
        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        this.status = this.querySelector('[data-mc-pdp-status]');
        if (!this.form) return;
        this.on(this.form, 'submit', (event) => {
          event.preventDefault();
          this.addToCart(event.submitter);
        });
      }

      async addToCart(opener) {
        if (this.busy) return;
        const buttons = Array.from(this.querySelectorAll('[data-mc-pdp-add]'));
        this.busy = true;
        buttons.forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });
        this.setStatus('');

        const cart = window.Montecapra && window.Montecapra.cart;
        if (!cart) {
          this.form.submit();
          return;
        }

        try {
          await cart.add(new FormData(this.form), { opener });
          this.setStatus(this.dataset.textAdded, 'success');
        } catch (error) {
          this.setStatus(error.message || this.dataset.textError, 'error');
        } finally {
          this.busy = false;
          const available = this.variantAvailable !== false;
          buttons.forEach((button) => {
            button.disabled = !available;
            button.removeAttribute('aria-busy');
          });
          // Disabling the button during the request drops focus to the page; the drawer no longer opens to take it.
          if (opener && opener.isConnected && !opener.disabled && (!document.activeElement || document.activeElement === document.body)) {
            opener.focus({ preventScroll: true });
          }
        }
      }

      initPairing() {
        this.querySelectorAll('[data-mc-pair-add]').forEach((button) => {
          this.on(button, 'click', async () => {
            const cart = window.Montecapra && window.Montecapra.cart;
            const card = button.closest('[data-mc-pair]');
            const status = card ? card.querySelector('[data-mc-pair-status]') : null;
            if (!cart) {
              window.location.href = card.querySelector('a[href]').href;
              return;
            }
            if (button.getAttribute('aria-busy') === 'true') return;
            button.setAttribute('aria-busy', 'true');
            if (status) status.textContent = '';
            try {
              await cart.add([{ id: Number(button.dataset.mcPairAdd), quantity: 1 }], { opener: button });
              if (status) status.textContent = this.dataset.textAdded;
            } catch (error) {
              if (status) status.textContent = error.message || this.dataset.textError;
            } finally {
              button.removeAttribute('aria-busy');
            }
          });
        });
      }

      setStatus(message, state) {
        if (!this.status) return;
        this.status.textContent = message;
        if (state) this.status.dataset.state = state;
        else delete this.status.dataset.state;
      }

      initSticky() {
        const bar = this.querySelector('[data-mc-pdp-sticky]');
        const buy = this.querySelector('[data-mc-pdp-buy]');
        const end = this.querySelector('[data-mc-pdp-end]');
        if (!bar || !buy || !end || !('IntersectionObserver' in window)) return;
        let buyPassed = false;
        let endPassed = false;
        const update = () => {
          const visible = buyPassed && !endPassed;
          bar.classList.toggle('is-visible', visible);
          bar.inert = !visible;
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const above = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            if (entry.target === buy) buyPassed = above;
            if (entry.target === end) endPassed = above;
          });
          update();
        });
        observer.observe(buy);
        observer.observe(end);
        this.observers.push(observer);
      }

      initReveal() {
        const items = Array.from(this.querySelectorAll('[data-mc-reveal]'));
        if (this.reduceMotion || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
          items.forEach((item) => item.classList.add('is-revealed'));
          return;
        }
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        );
        items.forEach((item) => observer.observe(item));
        this.observers.push(observer);
      }
    }

    customElements.define('mc-product-page', McProductPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-ritual-scroll"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('mc-sequence:progress', (event) => {
    const section = event.target.closest('.mc-rs');
    if (!section) return;

    const progress = event.detail.progress;
    section.style.setProperty('--rs-progress', progress.toFixed(3));

    const steps = Array.from(section.querySelectorAll('.mc-rs__step'));
    steps.forEach((step, index) => {
      const next = steps[index + 1];
      const active = progress >= Number(step.dataset.from) && (!next || progress < Number(next.dataset.from));
      step.classList.toggle('is-active', active);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montecapra-suscripciones-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mc-subscription-builder')) return;

    const AMOUNT_PATTERN = /\{\{\s*(\w+)\s*\}\}/;
    const THOUSANDS = {
      amount: ',',
      amount_no_decimals: ',',
      amount_with_comma_separator: '.',
      amount_no_decimals_with_comma_separator: '.',
      amount_with_space_separator: ' ',
      amount_no_decimals_with_space_separator: ' ',
      amount_with_period_and_space_separator: ' ',
      amount_with_apostrophe_separator: "'",
    };

    const formatMoney = (value, format) => {
      const amount = Math.max(0, Math.round(Number(value) || 0));
      const match = format.match(AMOUNT_PATTERN);
      const separator = (match && THOUSANDS[match[1]]) || '.';
      const digits = String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
      return match ? format.replace(AMOUNT_PATTERN, digits) : `$${digits}`;
    };

    const fill = (template, values) =>
      Object.keys(values).reduce((text, key) => text.split(`[${key}]`).join(values[key]), template || '');

    const readPlans = (element) => {
      try {
        const plans = JSON.parse((element && element.textContent) || '[]');
        return Array.isArray(plans) ? plans : [];
      } catch (error) {
        return [];
      }
    };

    const isTreliUrl = (value) => {
      try {
        const url = new URL(value);
        return url.protocol === 'https:' && url.hostname === 'checkout.treli.co';
      } catch (error) {
        return false;
      }
    };

    class McSubscriptionBuilder extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.config = {
          plans: readPlans(this.querySelector('[data-mc-subscription-plans]')),
          quantities: String(this.dataset.quantities || '')
            .split(',')
            .map((value) => Number(value))
            .filter((value) => value > 0)
            .sort((a, b) => a - b),
          usage: String(this.dataset.usage || '')
            .split('|')
            .map((pair) => {
              const [min, ...rest] = pair.split(':');
              return { min: Number(String(min).trim()), value: rest.join(':').trim() };
            })
            .filter((pair) => Number.isFinite(pair.min) && pair.value)
            .sort((a, b) => a.min - b.min),
          moneyFormat: this.dataset.moneyFormat || '',
        };

        const checkedQuantity = this.querySelector('[data-mc-subscription-quantity] input:checked');
        const total = Math.max(2, Number(checkedQuantity && checkedQuantity.value) || 60);
        this.state = { total, dark: this.clampDark(Number(this.dataset.initialDark), total) };

        this.addEventListener('change', (event) => this.onChange(event), { signal });
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.render(false);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        clearTimeout(this.announceTimer);
      }

      clampDark(value, total) {
        const half = total / 2;
        const steps = Math.round((Number(value) || 0) / half);
        return Math.min(2, Math.max(0, steps)) * half;
      }

      onChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;

        if (input.closest('[data-mc-subscription-quantity]')) {
          const nextTotal = Math.max(2, Number(input.value) || 60);
          const share = this.state.total > 0 ? this.state.dark / this.state.total : 0.5;
          this.state = { total: nextTotal, dark: this.clampDark(nextTotal * share, nextTotal) };
          this.render(true);
        } else if (input.closest('[data-mc-subscription-plan]')) {
          this.render(true);
        }
      }

      onClick(event) {
        const stepButton = event.target.closest('[data-mc-subscription-step]');
        if (stepButton && this.contains(stepButton)) {
          if (stepButton.getAttribute('aria-disabled') === 'true') return;
          const delta = (Number(stepButton.dataset.direction) || 0) * (this.state.total / 2);
          const darkDelta = stepButton.dataset.mcSubscriptionStep === 'dark' ? delta : -delta;
          this.state.dark = this.clampDark(this.state.dark + darkDelta, this.state.total);
          this.render(true);
          return;
        }

        const cta = event.target.closest('[data-mc-subscription-cta="treli"]');
        if (cta && this.contains(cta) && cta.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }

      coffee() {
        const { total, dark } = this.state;
        if (dark === total) return 'dark';
        if (dark === 0) return 'siena';
        return dark * 2 === total ? 'mixta' : '';
      }

      offer(plan, total, coffee) {
        const entry = plan && plan.offers ? plan.offers[`${coffee}_${total}`] : null;
        const url = entry && isTreliUrl(entry.url) ? entry.url : '';
        const price = url ? Math.max(0, Number(entry.price) || 0) : 0;
        const rawDiscount = entry && entry.discount !== null && entry.discount !== undefined ? Number(entry.discount) : NaN;
        const discount = price > 0 && rawDiscount >= 0 && rawDiscount <= 90 ? rawDiscount : null;
        const listPrice = discount === null ? 0 : Math.round((price * 100) / (100 - discount));
        const confirmed = discount !== null && this.isConsistent(total, listPrice);
        return { price, url, discount: confirmed ? discount : null, listPrice: confirmed ? listPrice : 0 };
      }

      // A discount is only shown as confirmed when the list price it implies matches the one implied by the
      // other Treli plans with the same quantity; otherwise the advertised percentage doesn't fit the price.
      isConsistent(total, listPrice) {
        if (!listPrice) return false;
        const counts = new Map();
        this.config.plans.forEach((plan) => {
          Object.keys((plan && plan.offers) || {}).forEach((key) => {
            const entry = plan.offers[key];
            if (!key.endsWith(`_${total}`) || !isTreliUrl(entry.url) || entry.discount === null) return;
            const discount = Number(entry.discount);
            const price = Number(entry.price) || 0;
            if (!(price > 0) || !(discount >= 0 && discount <= 90)) return;
            const implied = Math.round((price * 100) / (100 - discount));
            counts.set(implied, (counts.get(implied) || 0) + 1);
          });
        });
        if (counts.size <= 1) return true;
        const [reference, votes] = Array.from(counts.entries()).sort((a, b) => b[1] - a[1])[0];
        const tied = Array.from(counts.values()).filter((value) => value === votes).length > 1;
        return !tied && Math.abs(listPrice - reference) <= 1;
      }

      planInputs() {
        return Array.from(this.querySelectorAll('[data-mc-subscription-plan] input[type="radio"]'));
      }

      snapshot() {
        const inputs = this.planInputs();
        const plan = inputs.find((input) => input.checked) || inputs[0];
        const planIndex = plan ? Number(plan.value) : 0;
        const months = Math.max(1, Number(plan && plan.dataset.months) || 1);
        const { total, dark } = this.state;
        const coffee = this.coffee();
        const { price, url, discount, listPrice } = this.offer(this.config.plans[planIndex], total, coffee);

        return {
          total,
          dark,
          siena: total - dark,
          coffee,
          plan: plan ? plan.dataset.title : '',
          planIndex,
          months,
          discount,
          listPrice,
          cyclePrice: price,
          savings: listPrice ? Math.max(0, listPrice - price) : 0,
          url: this.dataset.ctaMode === 'treli' && price > 0 ? url : '',
        };
      }

      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element && element.textContent !== String(value)) element.textContent = value;
      }

      render(announce) {
        const data = this.snapshot();
        const money = (value) => (value > 0 ? formatMoney(value, this.config.moneyFormat) : this.dataset.unavailablePrice || '');

        this.querySelectorAll('[data-mc-subscription-step]').forEach((button) => {
          const key = button.dataset.mcSubscriptionStep;
          const value = key === 'dark' ? data.dark : data.siena;
          const atLimit = Number(button.dataset.direction) < 0 ? value <= 0 : value >= data.total;
          button.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
        });

        this.setText('[data-mc-subscription-count="dark"]', data.dark);
        this.setText('[data-mc-subscription-count="siena"]', data.siena);
        this.setText('[data-mc-subscription-total-label]', data.total);
        this.style.setProperty('--mc-sub-dark-share', `${data.total ? (data.dark / data.total) * 100 : 50}%`);

        const usage = this.config.usage.reduce((label, pair) => (data.total >= pair.min ? pair.value : label), '');
        this.setText('[data-mc-subscription-usage]', usage);

        this.querySelectorAll('[data-mc-subscription-tier]').forEach((item) => {
          const index = Number(item.dataset.mcSubscriptionTier);
          const { discount } = this.offer(this.config.plans[index], data.total, data.coffee);
          const discountElement = item.querySelector('[data-mc-subscription-tier-discount]');
          if (discountElement) discountElement.textContent = discount === null ? '—' : `${discount}%`;
          if (index === data.planIndex) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });

        const nextQuantity = this.config.quantities.find((quantity) => quantity > data.total);
        const nextDiscount = nextQuantity
          ? Math.max(0, ...this.config.plans.map((plan) => this.offer(plan, nextQuantity, data.coffee).discount || 0))
          : 0;
        this.setText(
          '[data-mc-subscription-nudge]',
          nextQuantity && nextDiscount > 0
            ? fill(this.dataset.nudgeTemplate, { min: nextQuantity, discount: nextDiscount })
            : (!nextQuantity && this.dataset.nudgeMax) || ''
        );

        this.planInputs().forEach((input) => {
          const card = input.closest('.mc-sub__plan');
          if (!card) return;
          const { price } = this.offer(this.config.plans[Number(input.value)], data.total, data.coffee);
          const cycleElement = card.querySelector('[data-mc-subscription-plan-cycle]');
          if (cycleElement) cycleElement.textContent = money(price);
        });

        this.setText('[data-mc-subscription-sum="total"]', data.total);
        this.setText('[data-mc-subscription-sum="dark"]', data.dark);
        this.setText('[data-mc-subscription-sum="siena"]', data.siena);
        this.setText('[data-mc-subscription-sum="plan"]', data.plan);
        this.setText('[data-mc-subscription-sum="list"]', money(data.listPrice));
        this.setText(
          '[data-mc-subscription-sum="discount"]',
          data.discount === null ? this.dataset.discountPending || '' : `${data.discount}%`
        );
        this.setText('[data-mc-subscription-sum="savings"]', money(data.savings));
        this.querySelectorAll('[data-mc-subscription-row]').forEach((row) => {
          row.hidden = !data.listPrice;
        });
        this.setText('[data-mc-subscription-sum="cycle"]', money(data.cyclePrice));
        this.setText('[data-mc-subscription-sum="months"]', data.months);

        const commitmentRow = this.querySelector('[data-mc-subscription-sum="commitment-row"]');
        if (commitmentRow) commitmentRow.hidden = data.months <= 1;

        const cta = this.querySelector('[data-mc-subscription-cta="treli"]');
        if (cta) {
          if (data.url) {
            cta.setAttribute('href', data.url);
            cta.removeAttribute('aria-disabled');
          } else {
            cta.removeAttribute('href');
            cta.setAttribute('aria-disabled', 'true');
          }
          this.setText('[data-mc-subscription-note]', data.url ? this.dataset.note || '' : this.dataset.unavailable || '');
        }

        this.dataset.total = data.total;
        this.dataset.dark = data.dark;
        this.dataset.siena = data.siena;
        this.dataset.coffee = data.coffee;
        this.dataset.planIndex = data.planIndex;
        this.dataset.months = data.months;

        this.dispatchEvent(new CustomEvent('mc:subscription:change', { bubbles: true, detail: data }));

        if (announce) this.announce(data, money);
      }

      announce(data, money) {
        const live = this.querySelector('[data-mc-subscription-live]');
        if (!live) return;
        const names = Array.from(this.querySelectorAll('[data-mc-subscription-variety]')).map(
          (row) => row.dataset.name || ''
        );
        clearTimeout(this.announceTimer);
        this.announceTimer = setTimeout(() => {
          live.textContent = fill(this.dataset.liveTemplate, {
            total: data.total,
            dark: data.dark,
            dark_name: names[0] || '',
            siena: data.siena,
            siena_name: names[1] || '',
            plan: data.plan,
            cycle: money(data.cyclePrice),
          });
        }, 450);
      }
    }

    customElements.define('mc-subscription-builder', McSubscriptionBuilder);
  })();

  } catch(e) { console.error(e); }
})();
})();
